import React, { Component } from 'react'
import { getOs } from '../../utils/utility'
import { getEnrolledMemberData, gethealthcard, getProgramInfo, getRxSimpleShareData } from '../ApiCall'
import moment from 'moment'
import { Modal } from 'react-bootstrap'
import { IconButton } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import CommonLoader from '../CommonLoader'

export default class RightDrawer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      link: 'https://members.myflexcare.com/login/member',
      fliptLink: '',
      pharmaShow: false,
      isRevive: false,
      reviveLink:"",
      loader: false,
    }
  }

  componentDidMount() {
    gethealthcard().then(resp => {
      let data = {
        memberSSN: resp.data.memberIdCardList[0].memberSSN,
        type: 'family'
      }
      getRxSimpleShareData(data).then(res => {
        if (res && Array.isArray(res)) {
          res.map(value => {
            if (value.addon.includes('RxSimpleShare') && value.status === 'AC') this.setState({ pharmaShow: true },()=>{
              localStorage.setItem('popupShow', "true");
            })
            if (value.addon.includes('Health Tools') && value.status === 'AC') this.setState({ isTelemed: true },()=>{
              localStorage.setItem('popupShow', "true");
            })
            if (value.addon.includes('UHSRx') && value.status === 'AC') this.setState({ isRevive : true }, ()=>{
              localStorage.setItem("isRevive", true)
            })
          })
        }
      })
      getProgramInfo()
      .then(res => {
        if (res.data && res.data.programInfo) {
          var str = res.data.programInfo.programName
          if (str.includes('+')) {
            var str1 = res.data.programInfo.programName
            var res1 = str1.split(' ')
            this.setState({ programname: res1[0], programname2: ' with ' + res1[2], showwithacsm: true })
          } else {
            this.setState({ programname: res.data.programInfo.programName, showwithacsm: false })
          }
        } else {
          this.setState({ loader: false })
        }
      })
      .catch()
    })
    var os = getOs()
    console.log('==========RIGHT DRAWER IS====', os)

    if (os == 'Mac OS') {
      this.setState({ link: 'https://members.myflexcare.com/login/member', 
        fliptLink: 'https://apps.apple.com/us/app/southern-scripts/id938009409',
        reviveLink:'https://apps.apple.com/us/app/revivehealth-mobile/id6450846042' })
    }
    if (os == 'iOS') {
      this.setState({
        link: 'https://apps.apple.com/us/app/mdlive/id839671393',
        fliptLink: 'https://apps.apple.com/us/app/southern-scripts/id938009409',
        reviveLink:'https://apps.apple.com/us/app/revivehealth-mobile/id6450846042'
      })
    }
    if (os == 'Windows') {
      this.setState({ link: 'https://members.myflexcare.com/login/member', 
        fliptLink: 'https://member.liviniti.com/home',
        reviveLink:'https://member.myrevive.health/' })
    }
    if (os == 'Android') {
      this.setState({
        link: 'https://play.google.com/store/apps/details?id=com.mdlive.mobile',
        fliptLink: 'https://play.google.com/store/apps/details?id=org.yappymobile.southernscripts&pli=1',
        reviveLink:'https://play.google.com/store/apps/details?id=health.revive.mobile&hl=en_US&pli=1'
      })
    }
    if (os == 'Linux') {
      this.setState({ link: 'https://members.myflexcare.com/login/member', 
        fliptLink: 'https://member.liviniti.com/home',
        reviveLink:'https://member.myrevive.health/' })
    }
  }

  opentelemed() {
    window.open(this.state.link)
  }
  openFlipt = () => {
    window.open(this.state.fliptLink)
  }
  openRevie = () => {
    window.open(this.state.reviveLink)
  }
  openCuramLifeCare=() => {
    var os = getOs()
    if (os == 'Mac OS'||os == 'Windows'||os == 'Linux')
    window.open("https://www.universalhealthfellowship.org/curamlife-care-coordination-app/")
    else if (os == 'iOS')
    window.open("https://apps.apple.com/us/app/curamlife/id1609101662")
    else if(os == 'Android')
    window.open("https://play.google.com/store/apps/details?id=com.curamlife")
  }

  openFlexcareSSO = async () => {
    try {
      this.setState({ loader: true, loader: true });
      getEnrolledMemberData().then(async (res) => {
        if (res && res.data) {
          let member = res.data[0]
      const ssoResp = await fetch(process.env.REACT_APP_SSO_TOKEN_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          api_key: process.env.REACT_APP_SSO_API_KEY,
          password: process.env.REACT_APP_SSO_API_PASSWORD
        })
      });

      let jwtToken = ssoResp.headers.get('authorization');
      if (!jwtToken) jwtToken = ssoResp.headers.get('Authorization');
      if (!jwtToken) throw new Error('SSO token not received in headers');

      const accessResp = await fetch(process.env.REACT_APP_CREATE_ACCESS_TOKEN_API, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': jwtToken
        },
        body: JSON.stringify({
          membership_number: member.memberId,
          group_id: 'CLTRL',
          first_name: member.firstName,
          last_name: member.lastName,
          date_of_birth: moment(member.dateOfBirth).format('MM/DD/YYYY'),
          gender: member.gender?.toUpperCase() === "M" ? "Male" : member.gender?.toUpperCase() === "F" ? "Female" : "",
          zip: member.zipCode,
          primary_reference: ''
        })
      });

      const accessData = await accessResp.json();

      // show modal if API returned non-ok or message (eg. "User not found.")
      if (!accessResp || (accessData && 'errorid' in accessData)) {
        const msg = accessData && accessData.message ? accessData.message : 'Unable to create access token. Please contact support.';
        this.setState({ loader: false, showSSOErrorModal: true, ssoErrorMessage: "User not registered with FlexCare" });
        return;
      }

      const encodedUser = accessData.encoded_user;

      if (!encodedUser) throw new Error('encoded_user not received');

      window.open(`${process.env.REACT_APP_SSO_URL}${encodedUser}`, '_blank');
      this.setState({ loader: false });
      }
      })
    } catch (error) {
      console.error(error);
      this.setState({ loader: false, showSSOErrorModal: true, ssoErrorMessage: 'Flexcare SSO failed. Please contact support.' });
    }
  }

  render() {
    return (
      <div>
        {this.state.loader ? <CommonLoader /> : null}
      <div class="rightdrawer">
        {/* <div class="rightdrawer_card text-center">
                    <img src={require('../Images/Card/health_services_icon.svg')} style={{height:'84px',width:'84px'}}/>
                    <div class="rightdrawer_card_name">Member Services</div>
              </div> */}

        {(( localStorage.getItem("planId")!=="10051" && localStorage.getItem("planId")!=="10052" && localStorage.getItem("planId")!=="10053"
        && localStorage.getItem("planId")!=="10061" && localStorage.getItem("planId")!=="10062" && localStorage.getItem("planId")!=="10063") || (this.state.programname?.includes("ES") && this.state.isTelemed)) && <div class="rightdrawer_card text-center" onClick={() => this.openCuramLifeCare()}>
          <img src={require('../Images/CuramLife (2).svg')} style={{  width: '90px', marginTop: '8px'}} />
          <div class="rightdrawer_card_name" style={{marginTop:"-3px"}}>CuramLife Care Coordination App</div>
        </div>}
        {this.state.pharmaShow && (localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599') && (
          <div class="rightdrawer_card text-center" onClick={() => this.openFlipt()}>
            <img src={require('../Images/NewIcons/pharma benefits icon (active).svg')} style={{ height: '84px', width: '84px' }} />
            <div class="rightdrawer_card_name">RxSimpleShare</div>
          </div>
        )}
        {this.state.isRevive && (localStorage.getItem('CLIENT_ID') != '5742' && localStorage.getItem('CLIENT_ID') != '4599') && (
          <div class="rightdrawer_card text-center" onClick={() => this.openRevie()}>
            <img src={require('../Images/NewIcons/pharma benefits icon (active).svg')} style={{ height: '84px', width: '84px' }} />
            <div class="rightdrawer_card_name">UHSRx</div>
          </div>
        )}
        {((this.state.isTelemed && this.state.programname?.includes("ES") || !this.state.programname?.includes("ES"))) && 
          <div class="rightdrawer_card text-center" onClick={() => this.opentelemed()}>
            <img src={require('../Images/NewIcons/telemed icon (active).svg')} style={{ height: '84px', width: '84px' }} />
            <div class="rightdrawer_card_name">Telemedicine</div>
          </div>}
        {/* <div class="rightdrawer_card text-center" >
            <img src={require('../Images/Card/pharma_benefits_icon_active.svg')} style={{height:'84px',width:'84px'}}/>
                    <div class="rightdrawer_card_name">Pharma Benefits</div>
            </div> */}

        {/* <div class="rightdrawer_card text-center">
            <img src={require('../Images/Card/my_vitals_icon.svg')} style={{height:'84px',width:'84px'}}/>
                    <div class="rightdrawer_card_name">My Vitals</div>
            </div> */}

        {/* <div class="rightdrawer_card text-center">
            <img src={require('../Images/Card/health_records_icon.svg')} style={{height:'84px',width:'84px'}}/>
                    <div class="rightdrawer_card_name">Health Records</div>
            </div> */}

        {/* <div class="rightdrawer_card text-center">
            <img src={require('../Images/Card/lab_reports_icon.svg')} style={{height:'84px',width:'84px'}}/>
                    <div class="rightdrawer_card_name">Lab Reports</div>
            </div> */}
      </div>
        <Modal
          size="small" centered backdrop="static"
          show={this.state.showSSOErrorModal}
          onHide={() => this.setState({ showSSOErrorModal: false })}
        >
          <Modal.Header>
            <Modal.Title>Message</Modal.Title>
            <IconButton aria-label="close" onClick={() => this.setState({ showSSOErrorModal: false })}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>
          <Modal.Body style={{ padding: 20 }}>
            <b>{this.state.ssoErrorMessage}</b>
          </Modal.Body>
        </Modal>
      </div>
    )
  }
}
